import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-web-ingestion-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './web-ingestion-modal.html',
  styleUrl: './web-ingestion-modal.scss',
})
export class WebIngestionModal {
  @Input() indexName: string = '';
  urlToCrawl: string = '';
  maxPages: number = 100;
  generatePreview: boolean = false;
  activeModal = inject(NgbActiveModal);

  confirm() {
    if (!this.urlToCrawl) return;
    this.activeModal.close({
      url: this.urlToCrawl.trim(),
      maxPages: this.maxPages && this.maxPages > 0 ? Number(this.maxPages) : 100,
      generatePreview: this.generatePreview,
    });
  }
}